import React from 'react';
import cn from 'classnames';
import { Visibility } from '../../../../../../../types/common-types';

import './style.scss';

interface Props {
  id?: string;
  visibility?: Visibility;
}

const Divider: React.FC<Props> = ({ id, visibility = Visibility.Visible }) => {
  return (
    <div
      id={id}
      styleName={cn('divider', {
        hidden: visibility === Visibility.Hidden,
      })}
    />
  );
};
export default Divider;
